import React from 'react';

const RadioButtonOffSvg = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="25"
            height="25"
            className="card__radio--unselected"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 96 960 960"
        >
            <path d="M480 976q-82.333 0-155.333-31.5t-127.334-85.833Q143 804.333 111.5 731.333T80 576q0-83 31.5-156t85.833-127q54.334-54 127.334-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82.333-31.5 155.333T763 858.667Q709 913 636 944.5T480 976Zm0-66.666q139.333 0 236.334-97.334 97-97.333 97-236 0-139.333-97-236.334-97.001-97-236.334-97-138.667 0-236 97Q146.666 436.667 146.666 576q0 138.667 97.334 236 97.333 97.334 236 97.334ZM480 576Z" />
        </svg>
    );
};

export default RadioButtonOffSvg;
